<template>
    <el-card>
        <el-page-header @back="close" content="用户信息"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form ref="form" :model="form" :rules="rules" :status-icon="true" label-width="100px">
                    <el-form-item label="用户名" prop="name">
                        <el-input v-model="form.name" maxlength="20" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="别名" prop="alias">
                        <el-input v-model="form.alias" maxlength="20" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password" v-if="this.id < 1">
                        <el-input v-model="form.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式" prop="phone">
                        <el-input v-model="form.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="roles">
                        <el-select v-model="form.roles" multiple style="width: 400px">
                            <el-option v-for="item in roles" :key="item.id" :label="item.description" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数据源" prop="datasourceId" v-if="$root.user.type === 'SYSTEM' && showDatasource()">
                        <RemoteSelect v-model="form.datasourceId" url="/datasource/list" labelName="description" v-if="this.id < 1"></RemoteSelect>
                        <span v-else>{{form.datasource.description}}({{form.datasource.name}})</span>
                    </el-form-item>
                    <el-form-item label="白名单" prop="source">
                        <el-input type="textarea" :rows="3" v-model="form.source"></el-input>
                        <p class="help-text">存在多个时，以半角“,”分隔。</p>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <RemoteSelect v-model="form.status" :options="$utils.getEnumOptions('status')" style="width: 200px"></RemoteSelect>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>
    import RemoteSelect from "@/components/RemoteSelect";

    export default {
        components: {
            RemoteSelect,
        },
        props: ["id"],
        data() {
            return {
                form: {
                    roles: [],
                    status: "ENABLE",
                    datasource: {}
                },
                  rules: {
                      name: [
                          {required: true, message: '请输入用户名'},
                          {min: 5, max: 20, message: '长度在 5 到 20 个字符'}
                      ],
                      alias: [
                          {required: true},
                          {min: 2, max: 20, message: '长度在20个字符之内'}
                      ],
                      password: [
                          {required: true},
                          {min: 14, max: 20, message: '长度在 14 到 20 个字符'}
                      ],
                      phone: [
                        {required: true, message: '请输入手机号'},
                        {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的中国大陆手机号', trigger: 'blur'
                        }
                      ],
                      roles: [
                          {required: true, type: "array", min: 1, message: "请选择角色"},
                      ],
                      datasourceId: [
                          {required: true, message: '请选择数据源'},
                      ],
                },
                roles: []
            };
        },
        beforeMount() {
            if (this.id > 0) {
                this.$axios.get("/user/get/" + this.id).then(response => {
                    let data = response.data;

                    let roles = [];
                    if (data['roles']) {
                        data['roles'].forEach(role => {
                            roles.push(role['id']);
                        })
                    }
                    data['roles'] = roles;

                    if (this.$root.user.type === "SYSTEM") {
                        this.$axios.post("/datasource/find", {
                            userId: this.id
                        }).then((resp2) => {
                            data['datasource'] = resp2['data'];
                            this.form = data;
                        })
                    } else {
                        this.form = data;
                    }
                });
            }
            this.$axios.get("/role/list").then(response => {
                // 不可选择系统保留的两个权限
                this.roles = response.data.filter(item => item['id'] > 2);
            });
        },
        methods: {
            showDatasource() {
                return this.$root.menus.findIndex(item => item['path'] === '/datasource/index') > -1;
            },
            submit() {
                let data = this.$utils.clone(this.form);
                let url = this.form.id ? "/user/edit" : "/user/save";

                let roles = [];
                if (this.form.roles) {
                    this.form.roles.forEach(role => {
                        roles.push({"id": role});
                    })
                }
                data['roles'] = roles;

                this.$utils.submit(this.$refs.form, url, data, () => {
                    this.$emit("close", true);
                });
            },
            close() {
                this.$emit("close", false);
            },
        },
    }
</script>